import React, {Component} from "react";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import Container from "../../../modules/commons/Container";
import ReceivingPartDGI from "./receivingPartDGI/receivingPartDGI";
import ReceivingPartNOS from "./receivingPartNOS/receivingPartNOS";

class ReceivingPart extends Component {
    render() {
        return (
            <Container>
                <Tabs>
                    <TabList>
                        <Tab id="button_navigate_dgi">DGI</Tab>
                        <Tab id="button_navigate_nos">NOS</Tab>
                    </TabList>
                    <TabPanel>
                        <ReceivingPartDGI {...this.props} />
                    </TabPanel>
                    <TabPanel>
                        <ReceivingPartNOS {...this.props} />
                    </TabPanel>
                </Tabs>
            </Container>
        );
    }
}

export default ReceivingPart;
